import { IStoreState, ThunkDispatch } from '.';
import { query, updateUser } from './api';

import { Action } from 'redux';
import PhoneNumber from 'awesome-phonenumber';
import { PhoneNumberEnrolment } from '../components/PhoneNumberInput';

// Types

export type AuthMethodState = {
  challengeQuestions: {
    enrolled: boolean,
    challengeQuestions: {
      questionId: string
      questionText: string
      actualAnswer: string
    }[]
  }
  oobPhone: {
    enrolled: boolean
    enrolments: PhoneNumberEnrolment[]
  }
  oobSms: {
    enrolled: boolean
    enrolments: PhoneNumberEnrolment[]
  }
  oobBio: {
    enrolled: boolean
  },
  pushOtp: {
    enrolled: boolean
  },
  trxSign: {
    enrolled: boolean
  },
  enrolledCredentials: any
}

type Partial<T> = {
  [P in keyof T]?: T[P];
};

export enum AuthMethod {
  ChallengeQuestions,
  OobSms
}

export interface ContactListItem {
  defaultFlag?: boolean
  isDefault?: boolean | string // isDefault (OOB SMS) is a extension with custom xsi:type, so node-soap parses it as string instead of boolean :(
  label: string
  phoneNumber: string
  lastModified?: string
  countryCode?: string
  areaCode?: string
}

export type ContactList = ContactListItem[]

// Initialization

const initialState: AuthMethodState = {
  challengeQuestions: {
    enrolled: false,
    challengeQuestions: []
  },
  oobPhone: {
    enrolled: false,
    enrolments: []
  },
  oobSms: {
    enrolled: false,
    enrolments: []
  },
  oobBio: {
    enrolled: false,
  },
  pushOtp: {
    enrolled: false,
  },
  trxSign: {
    enrolled: false,
  },
  enrolledCredentials: {}
}

// Action Definition

export const AUTHMETHOD_SET = 'authmethod/SET'
export const AUTHMETHOD_GET = 'authmethod/GET'
export const AUTHMETHOD_GETACSP = 'authmethod/GETACSP'
export const AUTHMETHOD_GETCREDENTIALS = 'authmethod/GETCREDENTIALS'
export const AUTHMETHOD_SETCHALLENGEQUESTIONS = 'authmethod/SETCHALLENGEQUESTIONS'

interface AuthMethodSet extends Action {
  type: typeof AUTHMETHOD_SET,
  method: AuthMethod
  enrolled: boolean
}

interface AuthMethodGet extends Action {
  type: typeof AUTHMETHOD_GET,
  enrolledCredentials: any
}

interface AuthMethodGetAcsp extends Action {
  type: typeof AUTHMETHOD_GETACSP,
  update: Partial<AuthMethodState>
}

interface AuthMethodGetCredentials extends Action {
  type: typeof AUTHMETHOD_GETCREDENTIALS,
  credentialMap: { [key: string]: boolean }
}

interface AuthMethodSetChallengeQuestions extends Action {
  type: typeof AUTHMETHOD_SETCHALLENGEQUESTIONS,
  challengeQuestions: {
    enrolled: boolean
    challengeQuestions: { questionId: string, questionText: string, actualAnswer: string }[]
  }
}


// Reducer


export default (state: AuthMethodState = initialState, action: Action) => {
  switch (action.type) {
    case AUTHMETHOD_GET: {
      let getAction = action as AuthMethodGet
      let enrolledCredentials = getAction.enrolledCredentials

      return {
        ...state,
        challengeQuestions: {
          enrolled: _.get(enrolledCredentials, 'challengeQuestionManagementResponse.payload.userChallQuesDataList', false) ? true : false,
          challengeQuestions: _.get(enrolledCredentials, 'challengeQuestionManagementResponse.payload.userChallQuesDataList.challengeQuestion', [])
        },
        /*              _.castArray(_.get(enrolledCredentials, 'acspManagementResponseData.payload.contactList', []))
                .map((contact:any) => ({ ...contact, phone: false, sms: true }))*/
        oobPhone: {
          enrolled: _.castArray(_.get(enrolledCredentials, 'oobPhoneManagementResponse.payload.contactList', [])).length > 0 ? true : false,
          enrolments:
            (_.castArray(_.get(enrolledCredentials, 'oobPhoneManagementResponse.payload.contactList', [])) as ContactList)
              .map(contact => ({
                key: contact.label,
                default: contact.defaultFlag,
                phoneNumber: new PhoneNumber("+" + (contact.countryCode || "") + (contact.areaCode || "") + contact.phoneNumber),
                lastModified: Date.parse(contact.lastModified || ""),
                fromDatabase: true,
              } as PhoneNumberEnrolment))
        },
        enrolledCredentials
      } as AuthMethodState
    }
    case AUTHMETHOD_GETACSP: {
      let getAction = (action as AuthMethodGetAcsp)
      console.log(state, getAction.update, { ...state, ...getAction.update })
      return {
        ...state,
        ...getAction.update
      }
    }
    case AUTHMETHOD_SETCHALLENGEQUESTIONS: {
      let setAction = (action as AuthMethodSetChallengeQuestions)
      return _.merge({}, state, { challengeQuestions: setAction.challengeQuestions }) as AuthMethodState
    }
    case AUTHMETHOD_GETCREDENTIALS: {
      let credentials = (action as AuthMethodGetCredentials).credentialMap
      return {
        ...state,
        challengeQuestions: {
          ...state.challengeQuestions,
          enrolled: credentials.QUESTION || false,
        },
        oobPhone: {
          ...state.oobPhone,
          enrolled: credentials.OOBPHONE || false,
        },
        oobSms: {
          ...state.oobSms,
          enrolled: credentials.OOBSMS || false,
        },
        oobBio: {
          ...state.oobBio,
          enrolled: credentials.OOBBIOMETRICS || false,
        },
        pushOtp: {
          ...state.pushOtp,
          enrolled: credentials.OTPMOBILEAPP || false,
        },
      }
    }
    default:
      return state
  }
}



// Action Creators

/* Assumes the user is logged in */

export const getCredentials = () =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let args = {
      actionTypeList: {
        genericActionTypes: "GET_USER_CREDENTIAL_EXTENDED"
      }
    }
    return dispatch(query(args)).then((data: any) =>
      data.userCredentials.credential
    ).then((credentials: any) => {
      let credentialMap: { [x: string]: boolean } = {}
      _.forEach(credentials, (credential: any) => {
        let key = credential.credentialType === "USER_DEFINED" ? credential.genericCredentialType : credential.credentialType
        let value = credential.credentialStatus
        credentialMap[key] = value === "ACTIVE"
      })
      dispatch({
        type: AUTHMETHOD_GETCREDENTIALS,
        credentialMap
      })
    }).catch((error: Error) => {
      console.error(error)
      // throw error
    })
  }
export const getEnrolledCredentials = () =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) =>
    dispatch(getEnrolledCredentialsForUser(getState().auth.userName))

export const getEnrolledCredentialsForUser = (userName: string) =>
  (dispatch: ThunkDispatch) => {
    let args = {
      identificationData: {
        userName
      },
      credentialManagementRequestList: {
        challengeQuestionManagementRequest: {
          payload: {
            actionTypeList: {
              challengeQuestionActionType: "GET_USER_QUESTION",
            }
          }
        },
        oobEmailManagementRequest: {
          payload: {
            oobActionTypeList: {
              oobActionType: "GET_OOB",
            }
          }
        },
        oobPhoneManagementRequest: {
          payload: {
            oobActionTypeList: {
              oobActionType: "GET_OOB",
            }
          }
        },
        /*acspManagementRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBSMSManagementRequest",
                xmlns: "http://ws.oobsms.csd.rsa.com"
              }
            },
            action: "GET"
          }
        }*/
      }
    }

    return dispatch(query(args)).then((data: any) =>
      data.credentialManagementResponseList
    ).then((list: any) => {
      dispatch({
        type: AUTHMETHOD_GET,
        enrolledCredentials: list
      } as AuthMethodGet)
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const getEnrolledOobBio = () =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let args = {
      actionTypeList: {
        genericActionTypes: "GET_USER_CREDENTIAL_EXTENDED",
      }
    }

    return dispatch(query(args)).then((data: any) => {
      let credential = _.find(data.userCredentials.credential, (uc: any) => uc.genericCredentialType === "OOBBIOMETRICS")
      return dispatch({
        type: AUTHMETHOD_GETACSP,
        update: {
          oobBio: {
            enrolled: credential && credential.credentialStatus === "ACTIVE"
          }
        } as Partial<AuthMethodState>
      } as AuthMethodGetAcsp)
    }
    ).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }
  export const getEnrolledPushOtp = () =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let args = {
      actionTypeList: {
        genericActionTypes: "GET_USER_CREDENTIAL_EXTENDED",
      }
    }

    return dispatch(query(args)).then((data: any) => {
      let credential = _.find(data.userCredentials.credential, (uc: any) => uc.genericCredentialType === "OTPMOBILEAPP")
      return dispatch({
        type: AUTHMETHOD_GETACSP,
        update: {
          pushOtp: {
            enrolled: credential && credential.credentialStatus === "ACTIVE"
          }
        } as Partial<AuthMethodState>
      } as AuthMethodGetAcsp)
    }
    ).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const getEnrolledTrxSign = () =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let args = {
      actionTypeList: {
        genericActionTypes: "GET_USER_CREDENTIAL_EXTENDED",
      }
    }

    return dispatch(query(args)).then((data: any) => {
      let credential = _.find(data.userCredentials.credential, (uc: any) => uc.genericCredentialType === "TRXSIGN")
      return dispatch({
        type: AUTHMETHOD_GETACSP,
        update: {
          trxSign: {
            enrolled: credential && credential.credentialStatus === "ACTIVE"
          }
        } as Partial<AuthMethodState>
      } as AuthMethodGetAcsp)
    }
    ).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const getEnrolledOobSms = () =>
  (dispatch: ThunkDispatch) => {
    let args = {
      credentialManagementRequestList: {
        acspManagementRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBSMSManagementRequest",
                xmlns: "http://ws.oobsms.csd.rsa.com"
              }
            },
            action: "GET"
          }
        }
      }
    }

    return dispatch(query(args)).then((data: any) => {
      let contactList = _.castArray(_.get(data.credentialManagementResponseList.acspManagementResponseData.payload, 'contactList', []))
      return dispatch({
        type: AUTHMETHOD_GETACSP,
        update: {
          oobSms: {
            enrolled: contactList.length > 0,
            enrolments: (contactList as ContactList).map(contact => ({
              key: contact.label,
              default: contact.isDefault === "true" || contact.isDefault === true,
              phoneNumber: new PhoneNumber("+" + (contact.countryCode || "") + (contact.areaCode || "") + contact.phoneNumber),
              lastModified: Date.parse(contact.lastModified || ""),
              fromDatabase: true,
            } as PhoneNumberEnrolment)
            )
          }
        } as Partial<AuthMethodState>
      } as AuthMethodGetAcsp)
    }
    ).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }
export const browseQuestions = () =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let args = {
      identificationData: {
        userName: state.auth.userName
      },
      credentialManagementRequestList: {
        challengeQuestionManagementRequest: {
          payload: {
            actionTypeList: {
              challengeQuestionActionType: "BROWSE_QUESTION",
            }
          }
        },
      }
    }

    return dispatch(query(args)).then((data: any) => {
      if (data.credentialManagementResponseList.challengeQuestionManagementResponse.payload.callStatus.statusCode !== "SUCCESS")
        throw new Error("query request failed while attempting to BROWSE_QUESTION")
      return data.credentialManagementResponseList.challengeQuestionManagementResponse.payload.browsableChallQuesGroupList.questionGroup.map((a: any) => a.challengeQuestion)
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

const setUserVerified = {
  actionTypeList: {
    genericActionTypes: "SET_USER_STATUS"
  },
  identificationData: {
    userStatus: "VERIFIED",
  }
}

export const setQuestions = (challengeQuestions: { questionId: string, questionText: string, actualAnswer: string }[]) =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let challengeQuestion = challengeQuestions.map(({ questionText, ...others }) => others)

    let args = _.merge({
      identificationData: {
        userName: state.auth.userName,
      },
      credentialManagementRequestList: {
        challengeQuestionManagementRequest: {
          payload: {
            actionTypeList: {
              challengeQuestionActionType: "SET_USER_QUESTION",
            },
            challengeQuestionList: {
              challengeQuestion
            }
          }
        },
      }
    }, setUserVerified)

    return dispatch(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'credentialManagementResponseList.challengeQuestionManagementResponse.payload.callStatus.statusCode', "")

      if (statusCode === "SUCCESS") {
        return dispatch(getEnrolledCredentials())
      }
      else
        throw Error("updateUser request failed while attempting to SET_USER_QUESTION")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const updateOobPhone = (contactList: ContactList) =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let args = _.merge({
      identificationData: {
        userName: state.auth.userName,
      },
      credentialManagementRequestList: {
        oobPhoneManagementRequest: {
          credentialProvisioningStatus: "ACTIVE",
          payload: {
            oobActionTypeList: {
              oobActionType: "UPDATE_OOB",
            },
            contactList
          }
        },
      }
    }, setUserVerified)

    return dispatch(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'credentialManagementResponseList.oobPhoneManagementResponse.payload.callStatus.statusCode', "")

      if (statusCode === "SUCCESS") {
        return true
      }
      else
        throw Error("updateUser request failed while attempting to UPDATE_OOB for OobPhone")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const deleteOobPhone = (contactList: ContactList) =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let args = {
      identificationData: {
        userName: state.auth.userName,
      },
      credentialManagementRequestList: {
        oobPhoneManagementRequest: {
          credentialProvisioningStatus: "ACTIVE",
          payload: {
            oobActionTypeList: {
              oobActionType: "DELETE_OOB",
            },
            contactList
          }
        },
      }
    }

    return dispatch<any>(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'credentialManagementResponseList.oobPhoneManagementResponse.payload.callStatus.statusCode', "")

      if (statusCode === "SUCCESS") {
        return true
      }
      else
        throw Error("updateUser request failed while attempting to DELETE_OOB for OobPhone")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }


export const updateOobSms = (contactList: ContactList, action: "ADD" | "UPDATE") =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let args = _.merge({
      identificationData: {
        userName: state.auth.userName,
      },
      credentialManagementRequestList: {
        acspManagementRequestData: {
          credentialProvisioningStatus: "ACTIVE",
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBSMSManagementRequest",
                xmlns: "http://ws.oobsms.csd.rsa.com"
              }
            },
            action,
            contactList
          }
        },
      }
    }, setUserVerified)

    return dispatch(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'credentialManagementResponseList.acspManagementResponseData.callStatus.statusCode', "")

      if (statusCode === "SUCCESS") {
        return true
      }
      else
        throw Error("updateUser request failed while attempting to UPDATE OobSms")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }
export const deleteOobSms = (contactList: ContactList) =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let args = {
      identificationData: {
        userName: state.auth.userName,
      },
      credentialManagementRequestList: {
        acspManagementRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBSMSManagementRequest",
                xmlns: "http://ws.oobsms.csd.rsa.com"
              }
            },
            action: "DELETE",
            contactList
          }
        },
      }
    }

    return dispatch<any>(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'credentialManagementResponseList.acspManagementResponseData.callStatus.statusCode', "")

      if (statusCode === "SUCCESS") {
        return true
      }
      else
        throw Error("updateUser request failed while attempting to DELETE for OobSms")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const updateOobBio = (enrolled: boolean) =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let args = _.merge({
      identificationData: {
        userName: state.auth.userName,
      },
      credentialManagementRequestList: {
        acspManagementRequestData: {
          credentialProvisioningStatus: enrolled ? "ACTIVE" : "DISABLED",
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBBioAuthManagementRequest",
                xmlns: "http://ws.oobbio.csd.rsa.com"
              }
            },
          }
        },
      }
    }, setUserVerified)

    return dispatch(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'credentialManagementResponseList.acspManagementResponseData.callStatus.statusCode', "")

      if (statusCode === "SUCCESS") {
        return true
      }
      else
        throw Error("updateUser request failed while attempting to UPDATE_OOB for OobBio")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }
export const updatePushOtp = (enrolled: boolean) =>
  (dispatch: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()

    let args = _.merge({
      identificationData: {
        userName: state.auth.userName,
      },
      credentialManagementRequestList: {
        acspManagementRequestData: {
          credentialProvisioningStatus: enrolled ? "ACTIVE" : "DISABLED",
          payload: {
            $attributes: {
              $xsiType: {
                type: "OTPMobileAppManagementRequest",
                xmlns: "http://ws.otpmobileapp.csd.rsa.com"
              }
            },
          }
        },
      }
    }, setUserVerified)

    return dispatch(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'credentialManagementResponseList.acspManagementResponseData.callStatus.statusCode', "")

      if (statusCode === "SUCCESS") {
        return true
      }
      else
        throw Error("updateUser request failed while attempting to UPDATE_PushOTP for Mobile")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  } 
export const enrolledCount = () =>
  (_: ThunkDispatch, getState: () => IStoreState) => {
    const am = getState().authmethods

    return [
      am.challengeQuestions.enrolled,
      am.oobPhone.enrolled,
      am.oobSms.enrolled,
      am.trxSign.enrolled,
      am.pushOtp.enrolled,
      am.oobBio.enrolled
    ].filter(v => v).length
  }
